import {chain2} from "@Common/utils/fs";

import {addVector}      from "./add-vector";
import {subtractVector} from "./subtract-vector";

export const alterPointByPixel = (p, scale, alterPoint) => chain2(p, [
    (_) => addVector(_, {x:.5, y:.5}),
    alterPoint,
    (_) => subtractVector(_, {x:.5 / scale, y:.5 / scale}),
]);

